import React, { Component } from 'react';
import "./whatsAppTemplates.css";
import { apiCall, PageScroller } from '../../helpers/api';
import Topbar from '../../components/topbar/Topbar';
import { Button, Col, Container, Dropdown, Modal, Row, Table, Form } from 'react-bootstrap';
import AdminNav from '../../components/adminnav/AdminNav';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import AlertModal from "../../components/alerts/alert";
import settings from './../../images/settings.svg';
import { Link } from 'react-router-dom';

export class WhatsAppTemplatesPage extends Component {
    constructor(props) {
        super(props);
        this.state ={
            newTemplate: null,
            newTemplateDetails: {"name": "", "templateType": "text", "content": "", "header": "", "footer": "", "buttons": []},
            editTemplate: null,
            templates: [],
            alert: {"display":"toast","visible":false,"title":"","content":""},
            counter: 0
        }
        this.availableTypes = [{value: "text", label: "Text"}, {value: "cta", label: "Call to Action"}, {value: "list", label: "Options"} ]
        this.animatedComponents = makeAnimated();
    }

    componentDidMount() {
    }

    async handleLoading(event, result) {
        result = await result;
        var tempTemplates = structuredClone(this.state.templates);
        if (event.pageData.page >= 1) {
            for (var x in result["whatsappTemplates"]) {
                tempTemplates.push(result["whatsappTemplates"][x])
            }
            this.setState({templates: tempTemplates})
        } else {
            this.setState({templates: result["whatsappTemplates"]})
        }
    }

    async createTemplate() {
        var response = await apiCall('whatsappTemplates', { "method" : "POST", "data": this.state.newTemplateDetails });
        if (response["success"]){
            this.setState({newTemplate: null, counter: this.state.counter + 1, newTemplateDetails: {"name": "", "templateType": "text", "content": "", "header": "", "footer": "", "buttons": []}})
            this.setState({alert: {"display":"toast","visible":true,"title":"Template Created","content":"WhatsApp Template Successfully Created","className":"bg-success text-white"}})
        }
        else if (response["failure"]){
            this.setState({alert: {"display":"toast","visible":true,"title":"Failed to Create Template","content":response["failure"]["error"],"className":"bg-danger text-white"}})
        }
    }

    async updateTemplate() {
        var response = await apiCall(`whatsappTemplates/${this.state.editTemplate._id}`, { "method" : "PUT", "data": this.state.editTemplate });
        if (response["success"]){
            this.setState({editTemplate: null, counter: this.state.counter + 1, alert: {"display":"toast","visible":true,"title":"Template Updated","content":"WhatsApp Template Successfully Updated","className":"bg-success text-white"}})
        }
        else if (response["failure"]){
            this.setState({alert: {"display":"toast","visible":true,"title":"Failed to Update Template","content":response["failure"]["error"],"className":"bg-danger text-white"}})
        }
    }

    async deleteTemplate(templateID) {
        var response = await apiCall(`whatsappTemplates/${templateID}`, { "method" : "DELETE" });
        if (response["success"]){
            this.setState({counter: this.state.counter + 1, alert: {"display":"toast","visible":true,"title":"Template Deleted","content":"WhatsApp Template Successfully Deleted","className":"bg-success text-white"}})
        }
        else if (response["failure"]){
            this.setState({alert: {"display":"toast","visible":true,"title":"Failed to Delete Template","content":response["failure"]["error"],"className":"bg-danger text-white"}})
        }
    }

    updateNewTemplate(e) {
        var tempDetails = structuredClone(this.state.newTemplateDetails);
        if (e.target.id == "templateType") {
            if (e.target.value == "text") {
                tempDetails.header = "";
                tempDetails.footer = "";
                tempDetails.buttons = [];
            } else if (e.target.value == "cta") {
                tempDetails.buttons = [{"text": "", "url": ""}]
            }
        }
        if (e.type == "ctaButton") {
            tempDetails.buttons[0][e.target.id] = e.target.value;
        }
        else if (e.type == "listOption") {
            tempDetails.buttons[e.index][e.target.id] = e.target.value;
        }
        else {
            tempDetails[e.target.id] = e.target.value;
        }
        this.setState({newTemplateDetails: tempDetails})
    }

    updateExistingTemplate(e) {
        var tempDetails = structuredClone(this.state.editTemplate);
        if (e.target.id == "templateType") {
            if (e.target.value == "text") {
                tempDetails.header = "";
                tempDetails.footer = "";
                tempDetails.buttons = [];
            } else if (e.target.value == "cta") {
                tempDetails.buttons = [{"text": "", "url": ""}]
            }
        }
        if (e.type == "ctaButton") {
            tempDetails.buttons[0][e.target.id] = e.target.value;
        }
        else if (e.type == "listOption") {
            tempDetails.buttons[e.index][e.target.id] = e.target.value;
        }
        else {
            tempDetails[e.target.id] = e.target.value;
        }
        this.setState({editTemplate: tempDetails})
    }

    render() {
        return (            
            <div className="bg-page influencers">
                <Topbar />
                <div className="pageName">WhatsApp Templates</div>
                <Container id="applicant-list-container" className="fullscreenWithTopBar top-0" fluid>
                    <AlertModal modal={this.state.alert} onClose={() => this.setState({alert: {"display":"toast","visible":false,"title":"","content":""}})} />
                    {this.state.newTemplate && 
                        <Modal show backdrop="static" centered size="lg" >
                            <Modal.Header className="pe-4">
                            <Modal.Title className="h5">
                                Add New Template
                            </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pb-0">
                                <Row>
                                    <Col xs={12} sm={12} md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="name" id="name" value={this.state.newTemplateDetails.name} onChange={(e) => this.updateNewTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} className="mb-3">
                                        <label>Template Type <span className="text-danger">*</span></label>
                                        <Select
                                            closeMenuOnSelect={true}
                                            components={this.animatedComponents}
                                            defaultValue={[]}
                                            options={this.availableTypes} 
                                            onChange={ (choice) => this.updateNewTemplate({"target":{"value":choice.value,"id":"templateType"}}) } 
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Header</Form.Label>
                                            <Form.Control type="name" id="header" disabled={this.state.newTemplateDetails.templateType == "text"} value={this.state.newTemplateDetails.header} onChange={(e) => this.updateNewTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Content <span className="text-danger">*</span></Form.Label>
                                            <textarea type="text" rows={5} cols={50} className="form-control" id="content" value={this.state.newTemplateDetails.content} onChange={(e) => this.updateNewTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Footer</Form.Label>
                                            <Form.Control type="name" id="footer" disabled={this.state.newTemplateDetails.templateType == "text"} value={this.state.newTemplateDetails.footer} onChange={(e) => this.updateNewTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    {this.state.newTemplateDetails.templateType != "text" && (
                                        <Col xs={12} sm={12} md={12}>
                                            <Form.Group className="mb-1">
                                                <Form.Label className="mb-1">Template Buttons</Form.Label>
                                                {this.state.newTemplateDetails.templateType == "cta" && (
                                                    <>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label className="mb-1">Button Text <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="name" id="text" value={this.state.newTemplateDetails.buttons[0].text} onChange={(e) => this.updateNewTemplate({target: {value: e.target.value, id: e.target.id}, type: "ctaButton"})} />
                                                        </Form.Group>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label className="mb-1">Button URL <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="name" id="url" value={this.state.newTemplateDetails.buttons[0].url} onChange={(e) => this.updateNewTemplate({target: {value: e.target.value, id: e.target.id}, type: "ctaButton"})} />
                                                        </Form.Group>
                                                    </>
                                                )}
                                                {this.state.newTemplateDetails.templateType == "list" && (
                                                    <>
                                                        <Row>
                                                            {this.state.newTemplateDetails.buttons.map((button, index) => (
                                                                <Col key={index} sm={4}>
                                                                    <Form.Group className="mb-1">
                                                                        <Form.Label className="mb-1">Option ID<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="name" id="id" value={button.id} onChange={(e) => this.updateNewTemplate({target: {value: e.target.value, id: e.target.id}, type: "listOption", index: index})} />
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-1">
                                                                        <Form.Label className="mb-1">Option Title<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="name" id="title" value={button.title} onChange={(e) => this.updateNewTemplate({target: {value: e.target.value, id: e.target.id}, type: "listOption", index: index})} />
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label className="mb-1">Option Description</Form.Label>
                                                                        <Form.Control type="name" id="description" value={button.description} onChange={(e) => this.updateNewTemplate({target: {value: e.target.value, id: e.target.id}, type: "listOption", index: index})} />
                                                                    </Form.Group>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                        <Button variant="outline-secondary" size="sm" onClick={() => {
                                                            var tempDetails = structuredClone(this.state.newTemplateDetails);
                                                            tempDetails.buttons.push({"description": "", "id": "", "title": ""});
                                                            this.setState({newTemplateDetails: tempDetails})
                                                        }}>Add Button</Button>
                                                    </>
                                                )}      
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                            </Modal.Body>
                            <Modal.Footer className="border-0 pt-0">
                                <Button variant="outline-secondary" size="sm" onClick={()=>this.setState({newTemplate: null, newTemplateDetails: {"name": "", "templateType": "text", "content": "", "header": "", "footer": "", "buttons": []}})}>Cancel</Button>
                                <Button onClick={() => this.createTemplate()} variant="success" size="sm">Create</Button>
                            </Modal.Footer>
                        </Modal>
                    }
                    {this.state.editTemplate && 
                        <Modal show backdrop="static" centered size="lg" >
                            <Modal.Header className="pe-4">
                            <Modal.Title className="h5">
                                Edit Template
                            </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pb-0">
                                <Row>
                                    <Col xs={12} sm={12} md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Name <span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="name" id="name" value={this.state.editTemplate.name} onChange={(e) => this.updateExistingTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={6} className="mb-3">
                                        <label>Template Type <span className="text-danger">*</span></label>
                                        <Select
                                            closeMenuOnSelect={true}
                                            components={this.animatedComponents}
                                            value={this.availableTypes.filter((type) => type.value === this.state.editTemplate.templateType)[0]}
                                            options={this.availableTypes} 
                                            onChange={ (choice) => this.updateExistingTemplate({"target":{"value":choice.value,"id":"templateType"}}) } 
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Header</Form.Label>
                                            <Form.Control type="name" id="header" disabled={this.state.editTemplate.templateType == "text"} value={this.state.editTemplate.header} onChange={(e) => this.updateExistingTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Content <span className="text-danger">*</span></Form.Label>
                                            <textarea type="text" rows={5} cols={50} className="form-control" id="content" value={this.state.editTemplate.content} onChange={(e) => this.updateExistingTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} sm={12} md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-1">Template Footer</Form.Label>
                                            <Form.Control type="name" id="footer" disabled={this.state.editTemplate.templateType == "text"} value={this.state.editTemplate.footer} onChange={(e) => this.updateExistingTemplate(e)} />
                                        </Form.Group>
                                    </Col>
                                    {this.state.editTemplate.templateType != "text" && (
                                        <Col xs={12} sm={12} md={12}>
                                            <Form.Group className="mb-1">
                                                <Form.Label className="mb-1">Template Buttons</Form.Label>
                                                {this.state.editTemplate.templateType == "cta" && (
                                                    <>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label className="mb-1">Button Text <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="name" id="text" value={this.state.editTemplate.buttons[0].text} onChange={(e) => this.updateExistingTemplate({target: {value: e.target.value, id: e.target.id}, type: "ctaButton"})} />
                                                        </Form.Group>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label className="mb-1">Button URL <span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="name" id="url" value={this.state.editTemplate.buttons[0].url} onChange={(e) => this.updateExistingTemplate({target: {value: e.target.value, id: e.target.id}, type: "ctaButton"})} />
                                                        </Form.Group>
                                                    </>
                                                )}
                                                {this.state.editTemplate.templateType == "list" && (
                                                    <>
                                                        <Row>
                                                            {this.state.editTemplate.buttons.map((button, index) => (
                                                                <Col key={index} sm={4}>
                                                                    <Form.Group className="mb-1">
                                                                        <Form.Label className="mb-1">Option ID<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="name" id="id" value={button.id} onChange={(e) => this.updateExistingTemplate({target: {value: e.target.value, id: e.target.id}, type: "listOption", index: index})} />
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-1">
                                                                        <Form.Label className="mb-1">Option Title<span className="text-danger">*</span></Form.Label>
                                                                        <Form.Control type="name" id="title" value={button.title} onChange={(e) => this.updateExistingTemplate({target: {value: e.target.value, id: e.target.id}, type: "listOption", index: index})} />
                                                                    </Form.Group>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label className="mb-1">Option Description</Form.Label>
                                                                        <Form.Control type="name" id="description" value={button.description} onChange={(e) => this.updateExistingTemplate({target: {value: e.target.value, id: e.target.id}, type: "listOption", index: index})} />
                                                                    </Form.Group>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                        <Button variant="outline-secondary" size="sm" onClick={() => {
                                                            var tempDetails = structuredClone(this.state.editTemplate);
                                                            tempDetails.buttons.push({"description": "", "id": "", "title": ""});
                                                            this.setState({editTemplate: tempDetails})
                                                        }}>Add Button</Button>
                                                    </>
                                                )}      
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                            </Modal.Body>
                            <Modal.Footer className="border-0 pt-0">
                                <Button variant="outline-secondary" size="sm" onClick={()=>this.setState({editTemplate: null})}>Cancel</Button>
                                <Button onClick={() => this.updateTemplate()} variant="success" size="sm">Update</Button>
                            </Modal.Footer>
                        </Modal>
                    }
                    <Row>
                        <AdminNav />
                        <div className="col-xl-12 col-xxl-10 px-0">
                            <div className="px-4 py-3 py-xl-4 bg-white shadow-sm">
                                <div className="d-flex align-items-center justify-content-between mx-xl-4">
                                <h1 className="pageTitle text-nowrap text-primary tragedyRegularFont fw-700 mb-0 fs-3">WhatsApp Templates</h1>
                                <button type='submit' className="link btn btn-sm btn-primary" onClick={() => this.setState({newTemplate: true})}>Create</button>
                                </div>
                            </div>     
                            <div className="p-4 pt-0 influencersTable mt-2 mt-xl-4 pb-0">
                                <div className="mx-xl-4">
                                <div className="tableHeaderFixedBelt"></div>
                                <Table className="border-transparent">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Template Type</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody className="small">
                                    {this.state.templates.map(template => (
                                        <tr key={template._id}>
                                            <td>
                                                {template.name}
                                            </td>
                                            <td>
                                                {this.availableTypes.filter(function(type) {return type.value == template.templateType})[0].label}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <Dropdown className="brandAction">
                                                        <Dropdown.Toggle variant="default" className="border-0">
                                                            <img src={settings} />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Link to={"#"} className="dropdown-item" onClick={() => this.setState({editTemplate: template})}>Edit</Link>
                                                            <Link to={"#"} className="dropdown-item" onClick={() => this.deleteTemplate(template._id)}>Delete</Link>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                        </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                                </div>
                                <PageScroller endpoint="whatsappTemplates" setState={this.handleLoading.bind(this)} pageSize={100} filter={this.state.counter} />
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default function WhatsAppTemplates() {
    return (
        <WhatsAppTemplatesPage />
    )
}